import { reviews, restaurant } from "../data";
import { Star, Quote } from "lucide-react";

function Card({ r }) {
  return (
    <div className="w-[320px] md:w-[380px] flex-shrink-0 rounded-2xl bg-[#1a1a1a] border border-white/10 p-6 mx-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1 text-[#eab308]">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={`${r.id}-star-${i}`} size={16} fill={i < r.score ? "#eab308" : "none"} strokeWidth={i < r.score ? 0 : 1.5} className={i < r.score ? "" : "text-white/20"} />
          ))}
        </div>
        <span className="text-[11px] uppercase tracking-widest text-[#a3a3a3]">{r.source}</span>
      </div>
      <Quote size={28} className="mt-4 text-[#e05d36]/40" />
      <p className="mt-2 text-[#d4d4cf] leading-relaxed">{r.text}</p>
      <p className="mt-4 font-semibold text-[#f5f5f0]">— {r.name}</p>
    </div>
  );
}

export default function Reviews() {
  const row = [
    ...reviews.map((r) => ({ ...r, key: `${r.id}-a` })),
    ...reviews.map((r) => ({ ...r, key: `${r.id}-b` })),
  ];
  return (
    <section id="reviews" data-testid="reviews-section" className="relative z-10 bg-[#0f0f0f] py-20 md:py-28 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-xl">
            <span className="text-xs uppercase tracking-[0.3em] text-[#e05d36] font-semibold">Das sagen unsere Gäste</span>
            <h2 className="mt-3 font-display font-black text-4xl md:text-5xl text-[#f5f5f0]">Bewertungen</h2>
          </div>
          <div className="flex gap-8">
            <div data-testid="reviews-google-stat" className="text-center">
              <div className="font-display font-black text-4xl text-[#eab308]">{restaurant.ratings.google.score}</div>
              <div className="text-sm text-[#a3a3a3]">Google · {restaurant.ratings.google.count}</div>
            </div>
            <div className="w-px bg-white/10" />
            <div data-testid="reviews-lieferando-stat" className="text-center">
              <div className="font-display font-black text-4xl text-[#eab308]">{restaurant.ratings.lieferando.score}</div>
              <div className="text-sm text-[#a3a3a3]">Lieferando · {restaurant.ratings.lieferando.count}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 relative">
        <div className="flex w-max marquee-slow">
          {row.map((r) => (
            <Card key={r.key} r={r} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0f0f0f] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0f0f0f] to-transparent" />
      </div>
    </section>
  );
}
